import styled from 'styled-components';
import { Col } from 'antd';

import { PagesHeading, UnderlineLink } from '../../../../CommonComponents/commonStyles';

export const GrantsHeading = styled(PagesHeading)`
  font-family: ${props => props.theme.fontFamily.berkeleyStd};
  letter-spacing: ${props => props.theme.letterSpacing.normal};
  @media (min-width: 320px) and (max-width: 768px) {
    font-size: ${props => props.theme.fontSize.h2};
    font-family: ${props => props.theme.fontFamily.berkeleyStd};
  }
`;

export const BottomSpan = styled.p`
  margin: 0;
  width: 62%;
  text-decoration: underline;
  cursor: pointer;
  font-family: ${props => props.theme.fontFamily.berkeleyStdMedium};
`;

export const Line = styled.div`
  position: absolute;
`;

export const OverView = styled(Col)`
  width: ${props => props.grantCounts === 0 ? '100%' : '40%'};
`;

export const Count = styled(Col)`
  width: 60%;
`;

export const GrantsCountMobile = styled.div`
  div {
    display: flex;
    align-items: center;
    justify-content: space-around;
    padding: 16px 0;
    padding-right: 25px;
  }
  margin: 20px 0;
  div span:first-child {
    width: 25%;
    text-align: center;
  }
  div span:nth-child(2) {
    width: 68%;
  }
  div:not(:last-child) {
    border-bottom: 2px solid #9b9b9b;
  }
  div img {
    cursor: pointer;
  }
`;

export const GrantCount = styled.span`
  font-size: 30px;
  color: ${props => props.theme.fontColors.textColor};
  letter-spacing: ${props => props.theme.letterSpacing.normal};
  font-family: ${props => props.theme.fontFamily.helveticaNeueLight};
  letter-spacing: ${props => props.theme.letterSpacing.zero};
`;

export const GrantText = styled(UnderlineLink)`
  color: ${props => props.theme.colors.primaryColor};
  font-size: ${props => props.theme.fontSize.heading};
  line-height: ${props => props.theme.lineHeight.tableFont};
  letter-spacing: ${props => props.theme.letterSpacing.normal};  
  cursor: pointer;
  width: 70%;
  &:hover {
  }
`;

export const GrantsCount = styled.div`
  display: flex;
  justify-content: flex-end;
  position: relative;
  div {
    display: inline-block;
    align-items: center;
    justify-content: center;
    position: relative;
    &::after {
      position: absolute;
      content: '';
      right: 11%;
      top: 11%;
    }
    span:first-child {
      letter-spacing: ${props => props.theme.letterSpacing.zero};
      font-family: ${props => props.theme.fontFamily.helveticaNeueLight};
      color: ${props => props.theme.fontColors.textColor};
      font-size: ${props => props.theme.fontSize.grantsCountSummary};
      text-align: center;
      height: 75px;
      line-height: normal;
    }
    a:last-child {
      height: 75px;
      color: ${props => props.theme.colors.primaryColor};
      font-size: ${props => props.theme.fontSize.h5};
      text-decoration: underline;
      width: 60%;
      display: inline-block;
      letter-spacing: ${props => props.theme.letterSpacing.normal};      
      line-height: ${props => props.theme.lineHeight.tableFont};
      vertical-align: middle;
      padding-left: 10px;
      font-family: ${props => props.theme.fontFamily.berkeleyStdMedium};
    }
  }
  div:not(:last-child) {
    /* added from mac */
    // border-right: 2px solid #9b9b9b;
    &::after {
      position: absolute;
      content: '';
      width: 2px;
      background-color: ${props => props.theme.backgroundColor.cardGridDivider};
      height: 43px;
      z-index: 5;
    }
  }
  div:not(:first-child) span {
    padding-left: 8px;
  }
  /* adding for mac resoloution */
  div:last-child span {
    padding-left: 0;
  }
`;
